// import { CartAddEvent } from '@theme/events';
class PangoCard {
  constructor(element) {
    this.element = element;
    this.variants = JSON.parse(this.element.dataset.variants || '[]');
    this.variantIdSpan = this.element.querySelector('[p-submit-btn');
    this.variantIdInput = this.element.querySelector('[pango-variant-id-input]');
    this.init();
  }

  init() {
    this.getSelectedVariantId();
    this.attachInputListeners();
    // this.form = this.element.querySelector('form');
    // this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  getSelectedVariantId() {
    const inputs = this.element.querySelectorAll('input[type="radio"]:checked');
    const selectedValues = [];

    inputs.forEach(input => {
      const position = parseInt(input.dataset.pangoOptionPosition, 10);
      const value = input.dataset.pangoOptionValue;
      selectedValues[position - 1] = value;
    });

    const selectedVariant = this.variants.find(variant =>
      variant.options.every((opt, i) => opt === selectedValues[i])
    );

    const submitButton = this.element.querySelector('button[type="submit"]');
    const available_text = submitButton.dataset.availableText;
    const not_available_text = submitButton.dataset.notAvailableText;
  
    if (selectedVariant) { 
      // console.log("Selected variant ID:", selectedVariant.id);    
      // LINK
      const linkElement = this.element.querySelector('a');
      const url = new URL(linkElement.href);
      url.searchParams.set('variant', selectedVariant.id);
      linkElement.href = url.toString();
      // IMAGE
      const imageElement = this.element.querySelector('img');
      let selectedVariantImage = selectedVariant.featured_image;
      if(selectedVariantImage){
        let selectedVariantImageSrc = selectedVariant.featured_image.src;
        imageElement.src= selectedVariantImageSrc;
        imageElement.srcset= selectedVariantImageSrc;
      }
      // TITLE
      const titleElement = this.element.querySelector('[data-pango-selected-variant-title]');
      titleElement.textContent=selectedVariant.title;    
      //PRICE
      const finalPrice = this.element.querySelector('[final-price]');
      const moneda = finalPrice.getAttribute('data-moneda')
      const comparePrice = this.element.querySelector('[compare-price]');
      finalPrice.textContent = this.formatCurrency(selectedVariant.price,moneda);
      if(selectedVariant.compare_at_price){
        comparePrice.textContent = this.formatCurrency(selectedVariant.compare_at_price,moneda);
        comparePrice.style.opacity="1";
        finalPrice.classList.add("p-sale");
      } else {
        comparePrice.style.opacity="0";
        finalPrice.classList.remove("p-sale");
      }
      // INPUT VARIANT ID
      this.variantIdInput.value = selectedVariant.id;
      // this.variantIdSpan = this.element.querySelector('[p-submit-btn]');
      // this.variantIdSpan.textContent = selectedVariant.id;

      if (selectedVariant.available) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-disabled');
        submitButton.innerText= available_text;
      } else {
        submitButton.disabled = true;
        submitButton.classList.add('is-disabled');
        submitButton.innerText= not_available_text;
      }
    } else {
      this.variantIdInput.value = '';
      submitButton.disabled = true;
      submitButton.classList.add('is-disabled');
    }
  }

  attachInputListeners() {
    const inputs = this.element.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.getSelectedVariantId();          
        if (parseInt(input.dataset.pangoOptionPosition, 10) === 1) {
          this.updateOption2Values(); // actualizar tallas si cambia el color
        }
      });
    });
  }

  static initAll() {
    const elements = document.querySelectorAll('[pango-card-class]');
    elements.forEach(el => new PangoCard(el));
  }

  updateOption2Values() {
    const colorInput = this.element.querySelector('input[data-pango-option-position="1"]:checked');
    if (!colorInput) return;
  
    const selectedColor = colorInput.dataset.pangoOptionValue;
  
    // Filtramos las variantes disponibles para ese color
    const validVariants = this.variants.filter(
      v => v.options[0] === selectedColor && v.available
    );
  
    // Obtenemos las tallas disponibles únicas y su orden
    const availableSizes = [...new Set(validVariants.map(v => v.options[1]))];
  
    const option2Container = this.element.querySelector('[data-pango-option-wrapper="2"]');
    if (!option2Container) return;
  
    option2Container.innerHTML = '';
  
    // Listamos todas las tallas posibles para ese color (disponibles o no)
    const allSizes = [...new Set(
      this.variants.filter(v => v.options[0] === selectedColor).map(v => v.options[1])
    )];
  
    allSizes.forEach(size => {
      const inputId = `option2-${size}-${Math.random().toString(36).substr(2, 5)}`;
      const isAvailable = availableSizes.includes(size);
  
      const label = document.createElement('label');
      label.innerHTML = `
        <input
          type="radio"
          name="option2"
          data-pango-option-position="2"
          data-pango-option-value="${size}"
          value="${size}"
          aria-label="${size}"
          ${isAvailable ? '' : 'aria-disabled="true"'}
        >
        <span class="p-talla">${size}</span>
      `;
      if (!isAvailable) label.classList.add('is-disabled');
  
      const input = label.querySelector('input');
      input.addEventListener('change', () => this.getSelectedVariantId());
  
      option2Container.appendChild(label);
    });
  
    // Marcar como checked la primera talla disponible
    const firstAvailableInput = option2Container.querySelector('input:not([disabled])');
    if (firstAvailableInput) {
      firstAvailableInput.checked = true;
    }
  
    // Recalcula variante
    this.getSelectedVariantId();
  }

  // format currency
  formatCurrency(number,moneda){
    const adjustedNumber = number / 100; 
    const [integer, decimal] = adjustedNumber.toFixed(2).split('.'); 
    return decimal === '00' ? ` ${moneda}${integer}` : ` ${moneda}${integer},${decimal}`;
  };
}

document.addEventListener('DOMContentLoaded', () => {
  PangoCard.initAll();
});
 
